export var globals = {
	showDebugForComponents: false,
    isMuted: false,
	memory: '',
	queryMemory: false
};